import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    creators: [],
    categories: [],
    categoryDisplay: '',
    showAllCreators: true
  },
  mutations: {
    addCategory: function(state, category) {
      state.categories.push(category);
    },
    setCategoryToDisplay: function(state, category) {
      state.categoryDisplay = category;
    },
    setShowAllCreators: function(state, show) {
      state.showAllCreators = show;
    }
  }
});


// WEBPACK FOOTER //
// ./src/store/index.js